<div class="docs-section" id="quickstart">
  <div class="docs-section__head">
    <h1 class="docs-h1">Quickstart</h1>
    <p class="docs-subtitle">From nothing to a first response, in three steps.</p>
  </div>
  <ol class="docs-timeline">
    <li><strong>Get an API key.</strong> Create one from <a class="link" routerLink="/api-keys">API Keys</a> it's tied to your organization's prepaid wallet balance.</li>
    <li><strong>Send a request.</strong> Any endpoint will do; the example below calls <code class="docs-param">rag</code>. See <a class="link" routerLink="/docs/authentication">Authentication</a> for the header shape.</li>
    <li><strong>Read the response.</strong> Check <span class="docs-param">X-Request-Cost-Cents</span> on the reply to see what it cost, and the <a class="link" routerLink="/docs/api-reference/rag">rag reference</a> for what came back.</li>
  </ol>
</div>

<div class="docs-section">
  <div class="docs-code-panel">
    <div class="docs-code-panel__header">
      <div class="docs-code-tabs">
        @for (lang of languages; track lang.id) {
          <button type="button" class="docs-code-tab" [class.docs-code-tab--active]="activeLang() === lang.id" (click)="setLang(lang.id)">{{ lang.label }}</button>
        }
      </div>
      <button type="button" class="docs-copy-btn" [class.docs-copy-btn--copied]="copied" (click)="copyCallExample()">
        @if (copied) {
          Copied
        } @else {
          <svg width="13" height="13" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 2a2 2 0 00-2 2v6a2 2 0 002 2h5a2 2 0 002-2V6.828a2 2 0 00-.586-1.414l-2.828-2.828A2 2 0 008.172 2H6Z" fill="currentColor"/><path d="M3 5a1 1 0 00-1 1v7a2 2 0 002 2h6a1 1 0 100-2H4V6a1 1 0 00-1-1Z" fill="currentColor"/></svg>
          Copy
        }
      </button>
    </div>
    <pre class="docs-code-pre" [innerHTML]="callExampleHtml"></pre>
  </div>

  <p class="docs-subtitle">Response:</p>

  <div class="docs-code-panel">
    <div class="docs-code-panel__header">
      <div class="docs-code-tabs">
        <button type="button" class="docs-code-tab docs-code-tab--active">200</button>
      </div>
    </div>
    <pre class="docs-code-pre" [innerHTML]="responseExampleHtml"></pre>
  </div>

  <p class="docs-subtitle">
    That's a complete call to <code class="docs-param">rag</code>. See <a class="link" routerLink="/docs/making-a-call">Making a call</a> for how the request/response body is shaped, or jump straight to the <a class="link" routerLink="/docs/api-reference">API reference</a>.
  </p>
</div>
